import { Link } from "react-router-dom";

// En-tête d'une carte lead : la tuile du produit, l'identité (nom, pastilles,
// dates, motif d'abandon) et les actions de traitement (statut, assignation,
// plus d'actions). Chaque page fournit son contenu ; la mise en page est la même.
const EnTeteCarte = ({ produit, idNom, nom, lien, puces, meta, motif, actions }) => (
  <header className="la-carte__tete">
    {produit}
    <div className="la-carte__identite">
      <div className="la-carte__ligne-nom">
        <h3 className="la-carte__nom" id={idNom}>
          {lien ? (
            <Link to={lien.to} target="_blank" title={lien.titre}>
              {nom}
              <i className="fa fa-external-link-alt" aria-hidden="true" />
            </Link>
          ) : (
            nom
          )}
        </h3>
        {puces}
      </div>
      {meta && <p className="la-carte__meta">{meta}</p>}
      {motif}
    </div>
    <div className="la-carte__actions">{actions}</div>
  </header>
);

export default EnTeteCarte;
